interface ProblemDetails {
  type: string;
  status: number;
  detail: string;
}

export const UNAUTHORIZED = "Unauthorized";
export class ApiError extends Error {
  constructor(error: ProblemDetails) {
    super(error.detail);
    this._problemDetails = error;
  }

  private _problemDetails: ProblemDetails;
  public get problemDetails(): ProblemDetails {
    return this._problemDetails;
  }
}

export class ForbiddenResultError extends Error {
  constructor() {
    super("Forbidden");
  }

  public get isForbiddenResult(): boolean {
    return true;
  }
}

export class UnauthorizedResultError extends Error {
  constructor() {
    super(UNAUTHORIZED);
  }

  public get isUnauthorizedResult(): boolean {
    return true;
  }
}

export function isApiError(error: Error): error is ApiError {
  return "problemDetails" in error;
}
export function isProblemDetails(error: any): error is ProblemDetails {
  return "type" in error && "status" in error;
}
